import styled from 'styled-components';

export const ScListingWrapper = styled.div`
  margin-top: 1.5em;
`;
